/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionDto } from '../../models/subscription-dto';

export interface BillingSubscriptionGet$Plain$Params {
}

export function billingSubscriptionGet$Plain(http: HttpClient, rootUrl: string, params?: BillingSubscriptionGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, billingSubscriptionGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionDto>;
    })
  );
}

billingSubscriptionGet$Plain.PATH = '/billing/subscription';
